import { FC } from 'react';

interface Props {
  label: string;
  value: string;
}

const PlayerMetric: FC<Props> = ({ label, value }) => {
  return (
    <div className='metric-container w-full text-center'>
      <p className='metric-label m-0 text-playerSecondaryTextColor text-4'>{label}</p>
      <p className='metric-value mt-2 mb-0 mx-0 text-hiContrast text-4 font-semibold'>{value}</p>
    </div>
  );
};

export default PlayerMetric;
